"use client";
import React from "react";
import { Popup, Button, Icon, Label } from "semantic-ui-react";

const FollowCityPopup = ({ loggedIn, isMobile, onSubscribeClick }) => {
  if (loggedIn) return null;

  return (
    <Popup
      size="small"
      position="bottom left"
      hoverable
      content="Receive an email when this city has new listings, score/ranking changes, new comments/questions, and more."
      trigger={
        <Button
          as="div"
          labelPosition="right"
          floated="right"
          onClick={() => onSubscribeClick("city")}
          className="theme_red btn_red"
        >
          {isMobile ? (
            <Icon
              size="big"
              name="heart outline"
              style={{
                margin: "-3px 0px 0px 0px",
                fontSize: "21px",
                color: "rgb(15, 20, 67)",
              }}
            />
          ) : (
            <>
              <Button className="btn_bg_static btn_alert" background="red">
                <img
                  src={
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/rsz_alerticon-removebg-preview.png"
                  }
                  width="15px"
                  alt="follow city"
                  title="follow city"
                />
              </Button>
              <Label
                as="a"
                name="saveNeighbor"
                content="Follow this City"
                basic
                pointing="left"
                className="theme_red btn_red track_button_satic"
              />
            </>
          )}
        </Button>
      }
    />
  );
};

export default FollowCityPopup;
